"use strict";

function IntegrationLogo(props) {
  return (
    <div className="fl right-gray-border">
      <a href={props.logoHref} target="_blank" className="integration-logo">
        <img src={props.logoSrc} />
      </a>
      <span className="centerer"></span>
    </div>
  );
};

IntegrationLogo.propTypes = {
  logoHref: React.PropTypes.string.isRequired,
  logoSrc: React.PropTypes.string.isRequired,
};

module.exports = IntegrationLogo;



// WEBPACK FOOTER //
// ./app/screens/Integration/shared/components/integration-logo.jsx